import {gql} from 'apollo-angular';

export const GET_PROFILES_ROOKIE_SUGGESTIONS = gql`
  query GetProfilesSearchResults ($search: String!, $limit: Int!) {
    companyProfileSearch(search: $search, limit: $limit) {
        id
        uuid
        name
    }
  }
`;
